export const data = {
	pin: {
		visible: false,
		href: 'https://www.fiat.com.br/concessionarias.html/?',
		target: '_blank',
	},
	list: [
		{
			label: 'UN VEHÍCULO QUE SE SUPERA',
			anchor: 'MainPage',
		},
		{
			label: 'FAMILIA STRADA',
			anchor: 'V360Page',
		},
		{
			label: 'FOTOS',
			anchor: 'GalleryPage',
		},
		{
			hideOnMobile: true,
			label: 'TODO SOBRE STRADA',
			anchor: 'AboutPage',
		},
		{
			openTab: true,
			label: 'DISEÑO IMPACTANTE',
			anchor: 'design',
			submenu: 'subitem',
			before: 'before-sub',
		},
		{
			openTab: true,
			label: 'FUERZA Y POTENCIA',
			anchor: 'forca-e-potencia',
			submenu: 'subitem',
			before: 'before-sub',
		},
		{
			openTab: true,
			label: 'TECNOLOGIA',
			anchor: 'tecnologia',
			submenu: 'subitem',
			before: 'before-sub',
		},
		{
			openTab: true,
			label: 'SEGURIDAD',
			anchor: 'seguranca',
			submenu: 'subitem',
			before: 'before-sub',
		},
		{
			openTab: true,
			label: 'ACCESORIOS',
			anchor: 'acessorios',
			submenu: 'subitem',
			before: 'before-sub',
		},
		/* 		{
			openTab: true,
			label: 'SERVICIOS',
			anchor: 'servicos',
			submenu: 'subitem',
			before: 'before-sub'
		}, */
		/* 		{
			hideOnMobile: true,
			label: 'CATÁLOGO DE PRODUCTO',
			href: '../../assets/NuevaStrada.pdf',
			target: '_blank',
		}, */
		{
			hideOnMobile: true,
			router: true,
			label: 'ELEGÍ LA TUYA',
			href: 'https://www.fiat.com.ar/contactanos.html',
			target: '_blank',
			dataLayerId: 'Menu_ClicouAgendeSeuTesteDrive',
		},
		{
			hideOnMobile: true,
			label: 'CONFIGURADOR',
			href: 'https://nuevastrada.fiat.com.ar/configurador.html',
			target: '_blank',
			dataLayerId: 'Menu_ClicouMonteOSeu',
		},
		{
			hideOnMobile: true,
			label: 'COMPRALO',
			href: 'https://www.fiat.com.ar/formularios-leads/formulario-nueva-strada.html',
			target: '_blank',
			dataLayerId: 'Menu_ClicouMonteOSeu',
		},
		{
			hideOnMobile: true,
			label: 'FICHA TÉCNICA',
			href: '../../assets/ft.pdf',
			target: '_blank',
			dataLayerId: 'Menu_ClicouMonteOSeu',
		},
	],
};

export default data;
